import { render, staticRenderFns } from "./live-play.vue?vue&type=template&id=4c172620&scoped=true&"
import script from "./live-play.vue?vue&type=script&lang=js&"
export * from "./live-play.vue?vue&type=script&lang=js&"
import style0 from "./live-play.vue?vue&type=style&index=0&id=4c172620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c172620",
  null
  
)

export default component.exports